
import Vue from 'vue'
import * as rules from 'vee-validate/dist/rules'
import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import { isObject } from 'lodash'
// import QUERY from 'lodash'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

localize({
  en: {
    messages: {
      required: field => {
        return `The ${field} field is required`
      },

      required_if: field => {
        return `The ${field} field is required`
      },

      email: field => {
        return `The ${field} must be a valid email address`
      },

      double: field => {
        return `The ${field} must be a valid number`
      },

      length: (field, option) => {
        if (option.length <= 1) {
          return `The ${field} must have ${option.length} character`
        }
        return `The ${field} must have ${option.length} characters`
      },

      between: (field, option) => {
        return `The ${field} must be between ${option.min} and ${option.max}`
      },

      max: (field, option) => {
        if (option.length <= 1) {
          return `The ${field} must be atleast lesser than or equal to ${option.length} character`
        }
        return `The ${field} must be atleast lesser than or equal to ${option.length} characters`
      },

      min: (field, option) => {
        if (option.length <= 1) {
          return `The ${field} must be atleast greater than or equal to ${option.length} character`
        }
        return `The ${field} must be atleast greater than or equal to ${option.length} characters`
      },

      max_value: (field, option) => {
        return `The ${field} must be atleast lesser than or equal to ${option.max}`
      },

      min_value: (field, option) => {
        return `The ${field} must be atleast greater than or equal to ${option.min}`
      },

      confirmed: (field, option) => {
        return `The ${field} must be the same as the value of ${option.target}`
      },

      excluded: (field, _option) => {
        // console.log('option', QUERY.mapKeys(option, (value, key) => {
        //   return QUERY.remove(excludedKeys, key)
        // }))

        // const excludedKeys = ['_field_', '_value_', '_rule_', 'excluded', 'month']

        // const x = QUERY.pull(QUERY.keys(option), excludedKeys)
        // console.log('option', option)

        return `The selected value for field ${field} is not allowed or already exists`
      },

      is: (field, { other }) => {
        return `The ${field} must be the same as the value of ${other}`
      }
    }
  }
})

extend('max_attachment', {
  validate: (attachments, { max }) => attachments.length <= max,
  params: ['max'],
  message: 'The number of attached files must not exceed {max}.'
})

extend('currency', {
  validate (value, { min, max }) {
    const transformToNumericValue = parseFloat(value.length ? value.replace(/,/g, '') : value)
    return !isNaN(transformToNumericValue) && transformToNumericValue >= min && transformToNumericValue <= max
  },
  params: ['min', 'max'],
  message: 'Please enter a valid currency amount and must be greater than {min} and lesser than {max}.'
})

extend('not_exists', {
  validate (value, { options, searchKey }) {
    if (Array.isArray(options) && options.length > 0) {
      const found = options.find(
        option => {
          const currentValue = isObject(value) && Object.keys(value).includes(searchKey) ? value[searchKey] : value

          return String(option) === String(currentValue)
        }
      )

      return !found
    }

    return true
  },
  params: ['options', 'searchKey'],
  message: (field, { _value_, searchKey, options }) => {
    if (Array.isArray(options) && options.length > 0) {
      if (isObject(_value_) && Object.keys(_value_).includes(searchKey)) {
        const alreadyExists = options.some(
          option => String(option) === String(_value_[searchKey])
        )
        if (alreadyExists) {
          return `The selected value for field ${field} already exists`
        }
      }

      return `The selected value for field ${field} is invalid`
    }
  }
})

extend('not_equal', {
  validate: (field, { target }) => field !== target,
  params: [{ name: 'target', isTarget: true }],
  message: (field, { target }) => `The ${field} must not be the same as the value of ${target}.`
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
